<template>
  <b-card>
    <b-container fluid class="p-0">
      <b-row class="pb-2">
        <b-col>
          <DatePicker
            v-model="date"
            :the-max-restriction-date="dateFromResponse"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <ConsumptionGraph
            :vector="vector"
            :date="date"
            :date-from-response="dateFromResponse"
            @set-date-from-response="setTheDateFromResponse"
            @it-is-not-visible="isVisibleConsumptionGraph = false"

            @loading-started="loadingStarted"
            @loading-finished="loadingFinished"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col v-if="isElectricEnergy">
          <Slots
            :date="date"
            :vector="vector"
            @set-date-from-response="setTheDateFromResponse"

            @loading-started="loadingStarted"
            @loading-finished="loadingFinished"
          />
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import moment from 'moment';
import ConsumptionGraph from './ConsumptionGraph';
import Slots from './Slots';
import DatePicker from './../ux/DatePicker';
import vectorMixin from './vector';

const ELECTRIC_ENERGY = 'EE';
moment.locale("it");
export default {
  components: {
    DatePicker,
    ConsumptionGraph,
    Slots,
  },

  mixins: [vectorMixin],

  props: {
    vector: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    localDate: moment().startOf('week'),

    isVisibleConsumptionGraph: true,

    processingCount: 0,
    theEarlierDateFromResponse: null,
  }),

  computed: {
    isElectricEnergy() {
      return this.vector === ELECTRIC_ENERGY;
    },
  },

  watch: {
    isVisibleConsumptionGraph(isVisible) {
      if (isVisible) {
        return;
      }

      this.$emit('hide');
    }
  },

  methods: {
    loadingStarted() {
      this.processingCount++;
    },

    loadingFinished() {
      this.processingCount--;

      // Check if there's date from response when all loading have finished
      if (this.processingCount === 0 && this.theEarlierDateFromResponse) {
        this.setDateFromResponse = true;
        this.localDate = this.theEarlierDateFromResponse;

        this.theEarlierDateFromResponse = null;
      }
    },

    /**
     * We save the most earlier date from responses until all loading not finished
     *
     * @param date
     */
    setTheDateFromResponse(date) {
      const dateFromResponse = moment(date);

      if (this.theEarlierDateFromResponse === null
        || this.theEarlierDateFromResponse > dateFromResponse
      ) {

        this.theEarlierDateFromResponse = dateFromResponse;
      }
    },

    loadData() {
      // We don't need to use it at all because this is a wrapper of 2 other widgets
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/widgets/ConsumptionAndSlots.vue